module.exports = __webpack_public_path__ + "fe402c479c9bc972419108d83e45d22b.png";